module.exports = __webpack_public_path__ + "img/DocBurgerMenuDemo.6ef35c36.gif";